import Modal from 'bootstrap/js/src/modal'
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.modal = new Modal(this.element, { backdrop: 'static', keyboard: false, focus: true })
    this.modal.show()
    this.element.addEventListener('turbo:submit-end', event => {
      if (event.detail.success) {
        document.location.reload()
      }
    })
  }
}
